import React from 'react';
import { Routes, Route } from 'react-router-dom';
import LandingContent from './components/LandingContent';
import LegalPage from './pages/LegalPage';
import CounsellorsPage from './pages/CounsellorsPage';
import TryDemoPage from './pages/TryDemoPage';
import AssessmentPage from './pages/AssessmentPage';
import StartPage from './pages/StartPage';
import PaymentPage from './pages/PaymentPage';
import SchoolEntryPage from './pages/SchoolEntryPage';
import ReportPreviewPage from './pages/ReportPreviewPage';
import AdminRoleDashboardPage from './pages/AdminRoleDashboardPage';
import NotFoundPage from './pages/NotFoundPage';
import UtmBootstrap from './components/UtmBootstrap';

function App() {
  return (
    <>
      <UtmBootstrap />
      <Routes>
      <Route path="/" element={<LandingContent />} />
      <Route path="/schools" element={<LandingContent />} />
      <Route path="/try" element={<TryDemoPage />} />
      <Route path="/start" element={<StartPage />} />
      <Route path="/payment" element={<PaymentPage />} />
      <Route path="/school/:schoolId" element={<SchoolEntryPage />} />
      <Route path="/report-preview/:token" element={<ReportPreviewPage />} />
      <Route path="/assessment" element={<AssessmentPage />} />
      <Route path="/privacy-policy" element={<LegalPage docKey="privacy" />} />
      <Route path="/terms-of-service" element={<LegalPage docKey="terms" />} />
      <Route path="/refund-policy" element={<LegalPage docKey="refund" />} />
      <Route path="/counsellors" element={<CounsellorsPage />} />
      <Route path="/admin" element={<AdminRoleDashboardPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
    </>
  );
}

export default App;
